// Modules
import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

// Hooks
import useLanguage from 'hooks/system/useLanguage'

// Constants
import { APPLICATION_URL_PATH_PREFIX } from 'constants/environment'
import { PRODUCT_NAME } from 'constants/meta'

// Component: Utility > Meta
function Meta ({ page, path }) {
	// Data
	const { translate } = useLanguage('components.utility.meta')
	const metaData = {
		title: getTitle(),
		url: getPermalink()
	}

	// Functions
	function getTitle () {
		let title = ''
		if (!!page) title += translate.global(`pages.${page}.name`)
		if (!!title) title += ' | '
		title += PRODUCT_NAME
		return title
	}
	function getPermalink () {
		let permalink = window.location.origin
		if (!!APPLICATION_URL_PATH_PREFIX) permalink += APPLICATION_URL_PATH_PREFIX
		if (!!path) permalink += path
		return permalink
	}

	// Render
	return page === 'error'
		? <Helmet>
			<meta
				name="robots"
				content="noindex, nofollow" />
			<meta
				name="googlebot"
				content="noindex" />
		</Helmet>
		: <Helmet>
			<title>{metaData.title}</title>
			<link
				rel="canonical"
				href={metaData.url} />
		</Helmet>
}

// Properties
Meta.propTypes = {
	page: PropTypes.string,
	path: PropTypes.string
}

// Export
export default Meta
